export enum ExternalEntitiesType {
    FamilyDoctor = 1,
    Anesthetist = 2,
}

export const ExternalEntitiesTypeLabels: Record<ExternalEntitiesType, string> = {
    [ExternalEntitiesType.FamilyDoctor]: "Family Doctor",
    [ExternalEntitiesType.Anesthetist]: "Anesthetist",
};